/* global d3 */
import util from './_utils';
import question_dropdowns from './question-dropdowns';
import lang from './lang';

//open questions
//lets use async instead of timeouts
//standardize Percent vs pct
//separate gs for bubbles, lines, etc.
//unhide mouseover magnet
let allRawData = null,
	lookupFile = null,
	allFormattedData = null,
	allFormattedDataNew = null,
	currentData = null,
	mouseNode = null,
	textNode = null,
	sizeAccessor = 'Percent',
	statusFilter = 'start',
	genderFilter = 'Total',
	nationalityFilter = 'Total',
	ageFilter = 'Total';

const graphic_container = d3.select('.graphic__chart'),
	svg = graphic_container.select('.svg__love-hate'),
	copy_panel = d3.select('.graphic__right.core-viz'),
	header = d3.select('.wwr-header'),
	tooltip = graphic_container.select('.cv-tooltip');

const needsToColors = {
	'Health': '#F8621F',
	'Aspiration': 'white',
	'Routine': '#999999',
	'Community': '#1F63F3',
}

const questionsToNeeds = {
	'Connect with others': 'Community',
	'Process life changes': 'Routine',
	'Feel accomplished': 'Aspiration',
	'Manage anxiety or depression': 'Aspiration',
	'More energy': 'Health',
	'Prevent illness or disease': 'Health',
	'Be healthier': 'Health',
	'Improve my body image': 'Health',
	'Get stronger': 'Health',
	//'Parents wanted to tire me out or teach me discipline': 'Routine',
}

let isMobile = null;

let vizParameters = null,
	questionCoords = null;

let simulation = d3.forceSimulation(),
	rScale = null,
	rAccessor = 'introRadius',
	forceStrength = .4,
	bubbles = null;

let currentLocation = 'center',
	mouseoverType = 'need',
	timeout = false;

let step = 0;

function init() {
	return new Promise((resolve, reject) => {
		Promise.all([
			d3.csv('assets/data/why_we_run_benefits.csv'),
			d3.csv('assets/data/why_we_run_lookup.csv'),
			d3.csv('assets/data/core_viz_sample_data.csv'),
		]).then(function(files) {
			allRawData = files[0];
			lookupFile = formatLookupFile(files[1]);
			allFormattedData = formatAllData(allRawData);

			drawMass('bottomCenter');
			// setupMouseoverText();
			resolve();
		}).catch(function(err) {
			console.log(err);
		})
	})
}

function next(index) {
	if (timeout) clearTimeout(timeout);
	removeMouseoverText();
	removeMouseoverButtons();
	massMouseoverOn(0, false);
	mouseout();

	step = index + 1;

	if (step === 0) {
		mouseoverType = 'need';
		removeQuestionLabels();
		moveMass('center', false);
		massMouseoverOn(1000, true);

		setTimeout(() => {
			setupMouseoverButtons()
		}, 2000);
	}

	if (step === 1) {
		mouseoverType = 'group';
		buildQuestionLabels();
		splitMass();
		question_dropdowns.toggleCV(lang.translateViz('cv', 'Dropdown--Started'), false);
		setTimeout(() => {
			setupMouseoverText()
		}, 2000);
	}

	if (step === 2) {
		mouseoverType = 'group';
		question_dropdowns.toggleCV(lang.translateViz('cv', 'Dropdown--Continue'), true);
	}
}

function formatLookupFile(data) {
	return data;
}

function formatAllData(data) {
	vizParameters = getVizParameters(),
		questionCoords = getEllipseCoords();

	const pctMin = .0002;
	const slimData = data.filter(d => +d[sizeAccessor] >= pctMin);

	const maxPct = d3.max(slimData, d => +d[sizeAccessor]);
	rScale = d3.scaleSqrt().domain([0, .08]).range([0, vizParameters.rMax]);

	let nodes = [];

	slimData.forEach(row => {
		const benefits = row.Benefits.split(',');

		benefits.forEach(benefit => {
			const question = lookupFile.filter(lookup => parseInt(lookup.Code) === parseInt(benefit))[0].Benefit;
			const need = questionsToNeeds[question];
			const coords = questionCoords[question];
			const color = needsToColors[need];

			const pct = +row[sizeAccessor],
				radiusSize = rScale(pct),
				introRadiusSize = radiusSize * (Math.random() * 5);

			nodes.push({
				question: question,
				group: row.Benefits,
				key: `${question},${row.Benefits}`,
				pct: pct,
				status: row['Question'],
				gender: row['Gender'],
				age: row['Age'],
				nationality: row['Nationality'],
				need: need,
				questionX: coords.x,
				questionY: coords.y,
				color: color,
				introRadius: introRadiusSize,
				realRadius: radiusSize,
				magnetized: false,
				fake: false,
			})
		})
	})

	mouseNode = {
		question: '',
		group: '',
		key: 'mouse',
		pct: 0,
		status: '',
		gender: '',
		age: '',
		nationality: '',
		need: '',
		questionX: '',
		questionY: '',
		color: '',
		introRadius: 100,
		realRadius: 100,
		magnetized: false,
		fake: true,
	}

	const textNodeRadius = 75;

	textNode = {
		question: '',
		group: '',
		key: 'text',
		pct: 0,
		status: '',
		gender: '',
		age: '',
		nationality: '',
		need: '',
		questionX: '',
		questionY: '',
		color: '',
		introRadius: textNodeRadius,
		realRadius: textNodeRadius,
		magnetized: false,
		fake: true,
	}

	shuffle(nodes);

	return nodes;
}

function resize() {
	stopSimulation();

	vizParameters = getVizParameters(),
		questionCoords = getEllipseCoords();

	rScale.range([0, vizParameters.rMax]);

	allFormattedData.forEach(d => {
		const coords = questionCoords[d.question];

		const radiusSize = rScale(d.pct),
			introRadiusSize = radiusSize * (Math.random() * 5);

		d.questionX = coords.x,
			d.questionY = coords.y,
			d.introRadius = introRadiusSize,
			d.realRadius = radiusSize;
	})

	bubbles.each(d => {
			const radiusSize = rScale(d.pct),
				introRadiusSize = radiusSize * (Math.random() * 5);

			d.introRadius = introRadiusSize,
				d.realRadius = radiusSize;
		})
		.attr('r', function(d) {
			if (d.key === 'mouse') return 100;
			//if (d.key === 'text') return getTextNodeRadius();
			return d[rAccessor];
		});

	if (currentLocation !== 'dispersed') {
		if (currentLocation === 'split') {
			simulation.force('x', d3.forceX().strength(forceStrength).x(d => d.questionX))
				.force('y', d3.forceY().strength(forceStrength).y(d => d.questionY));

		} else {
			const massCoords = getMassCoords(currentLocation);

			simulation.force('x', d3.forceX().strength(forceStrength).x(d => d.magnetized ? 300000 : massCoords.xPos))
				.force('y', d3.forceY().strength(forceStrength).y(d => d.magnetized ? 300000 : massCoords.yPos))
		}

		simulation.force('charge', d3.forceManyBody().strength(d => d.magnetized ? -15000 : charge(d)))
			.alpha(1).restart();

		if (timeout) clearTimeout(timeout);

		/*
		timeout = setTimeout(function() {
			moveQuestionLabels();
		}, 1300);
		*/
	}
}


function drawMass(location = 'center') {
	currentData = allFormattedData.filter(d => d.status === statusFilter && d.gender === genderFilter && d.age === ageFilter && d.nationality === nationalityFilter);
	//currentData.unshift(textNode);
	currentData.unshift(mouseNode);

	currentData.forEach(d => {
		d.x = vizParameters.fullWidth * Math.random(),
			d.y = util.randomNumber(vizParameters.fullHeight, vizParameters.fullHeight * 2);
	})

	const massCoords = getMassCoords(location);

	simulation = d3.forceSimulation()
		.alphaDecay(.0005)
		.velocityDecay(0.8)
		.force('charge', d3.forceManyBody().strength(d => d.magnetized ? -15000 : charge(d)))
		.on('tick', ticked);

	simulation.stop();

	bubbles = svg.selectAll('.bubble')
		.data(currentData, d => d.key);

	const bubblesE = bubbles.enter().append('circle')
		.classed('bubble', true)
		.attr('r', 0)
		.attr('fill', d => d.color)
		.attr('stroke', '#242428')
		.attr('stroke-width', 1)
		.style('pointer-events', 'none')
		.on('mouseover', mouseover)
		.on('mouseout', mouseout);

	bubbles = bubbles.merge(bubblesE);

	bubbles.attr('visibility', d => d.fake ? 'hidden' : 'visible')

	bubbles.transition()
		.duration(2000)
		.attr('r', d => d[rAccessor]);

	simulation.nodes(currentData);

	moveMass('bottomCenter', true);
}

function ticked() {
	bubbles.attr('cx', d => d.x)
		.attr('cy', d => d.y);

	const questions = Object.keys(questionsToNeeds);
	const splitMassCoords = {}

	questions.forEach(question => {
		const questionData = currentData.filter(d => d.question === question);
		//let questionY = isMobile ? d3.mean(questionData, d => d.y) : d3.min(questionData, d => d.y);
		let questionY = d3.min(questionData, d => d.y) + 10;
		const questionX = d3.mean(questionData, d => d.x);

		if (isMobile) questionY += 10;
		//if (isMobile && question === 'More energy') questionY += 10;

		splitMassCoords[question] = {
			questionX,
			questionY,
		};
	});

	graphic_container.selectAll('.cv-question-label')
		.each(function(dataA) {
			const a = this,
				nodeA = d3.select(a).node(),
				nodeAPos = splitMassCoords[dataA],
				nodeAWidth = nodeA.offsetWidth,
				nodeAHeight = nodeA.offsetHeight,
				nodeALeft = nodeAPos.questionX,
				nodeARight = nodeAPos.questionX + nodeAWidth,
				nodeATop = nodeAPos.questionY,
				nodeABottom = nodeAPos.questionY + nodeAHeight;

			graphic_container.selectAll('.cv-question-label')
				.each(function(dataB) {
					if (this != a) {
						const b = this,
							nodeB = d3.select(b).node(),
							nodeBPos = splitMassCoords[dataB],
							nodeBWidth = nodeB.offsetWidth,
							nodeBHeight = nodeB.offsetHeight,
							nodeBLeft = nodeBPos.questionX,
							nodeBRight = nodeBPos.questionX + nodeBWidth,
							nodeBTop = nodeBPos.questionY,
							nodeBBottom = nodeBPos.questionY + nodeBHeight;

						if ((Math.abs(nodeALeft - nodeBLeft) * 2 < (nodeAWidth + nodeBWidth)) &&
							(Math.abs(nodeATop - nodeBTop) * 2 < (nodeAHeight + nodeBHeight))) {

							var dx = (Math.max(0, nodeARight - nodeBLeft) + Math.min(0, nodeALeft - nodeBLeft)) * 0.05,
								dy = (Math.max(0, nodeABottom - nodeBTop) + Math.min(0, nodeATop - nodeBBottom)) * 0.05;

							splitMassCoords[dataA].questionX = nodeAPos.questionX + dx, splitMassCoords[dataA].questionY = nodeAPos.questionY + dy;
							splitMassCoords[dataB].questionX = nodeBPos.questionX - dx, splitMassCoords[dataB].questionY = nodeBPos.questionY - dy;
						}
					}
				});
		});

	graphic_container.selectAll('.cv-question-label')
		.style('left', d => `${splitMassCoords[d].questionX}px`)
		.style('top', d => `${splitMassCoords[d].questionY}px`)
}

function moveMass(location = 'center', magnetized = false) {
	currentData[0].magnetized = magnetized;

	const massCoords = getMassCoords(location);

	simulation.force('x', d3.forceX().strength(forceStrength).x(d => d.magnetized ? 300000 : massCoords.xPos))
		.force('y', d3.forceY().strength(forceStrength).y(d => d.magnetized ? 300000 : massCoords.yPos))
		.force('charge', d3.forceManyBody().strength(d => d.magnetized ? -15000 : charge(d)))
	//.force('center', d3.forceCenter(massCoords.xPos, massCoords.yPos))

	simulation.alpha(.8).restart();

	magnetizeSVG(magnetized);
}

function splitMass() {
	currentLocation = 'split';

	simulation.force('x', d3.forceX().strength(forceStrength).x(d => d.questionX))
		.force('y', d3.forceY().strength(forceStrength).y(d => d.questionY));

	simulation.alpha(1).restart();

	timeout = setTimeout(function() {
		showQuestionLabels();
	}, 1000);

	massMouseoverOn(1500, true);
}

function clearMass() {
	rAccessor = 'realRadius';

	massMouseoverOn(false);
	stopSimulation();

	graphic_container.selectAll('.cv-question-label')
		.transition()
		.duration(200)
		.style('opacity', 0)
		.remove();

	statusFilter = 'start',
		genderFilter = 'Total',
		nationalityFilter = 'Total',
		ageFilter = 'Total';

	currentData = allFormattedData.filter(d => d.status === statusFilter && d.gender === genderFilter && d.age === ageFilter && d.nationality === nationalityFilter);
	//currentData.unshift(textNode);
	currentData.unshift(mouseNode);

	// Apply the general update pattern to the nodes.
	bubbles = svg.selectAll('.bubble').data(currentData, d => d.key);

	bubbles.transition()
		.delay((d, i) => i * .2)
		.duration(1000)
		.attr('cx', d => {
			const currentX = d.x;
			if (d.x > vizParameters.width / 2) {
				d.x = vizParameters.width + 200 + (Math.random() * 100)
			} else {
				d.x = -200 - (Math.random() * 100);
			}
			return d.x;
		})
		.attr('r', d => d[rAccessor])
		.transition()
		.duration(0)
		.style('visibility', 'hidden');

	bubbles.exit()
		.transition()
		.duration(200)
		.attr('stroke-width', 0)
		.attr('r', 0)
		.remove();

	const bubblesE = bubbles.enter()
		.append('circle')
		.classed('bubble', true)
		.attr('cx', d => Math.random() > .5 ? vizParameters.width + 200 + (Math.random() * 100) : -200 - (Math.random() * 100))
		.attr('cy', d => util.randomNumber(vizParameters.height / 2 - 100, vizParameters.height / 2 + 100))
		//.attr('r', 0)
		.attr('r', d => d[rAccessor])
		.attr('stroke', '#242428')
		.attr('fill', d => d.color)
		.attr('stroke-width', 1)
		.attr('visibility', 'hidden')
		.on('mouseover', mouseover)
		.on('mouseout', mouseout);

	bubblesE.each(function(d) {
		d.x = +d3.select(this).attr('cx');
		d.y = +d3.select(this).attr('cy');
	})

	bubbles = bubbles.merge(bubblesE);

	bubbles.attr('visibility', d => d.fake ? 'hidden' : 'visible');

	simulation.nodes(currentData);

	currentLocation = 'dispersed';
}

function updateMassRadius(radiusSize = 'intro') {
	radiusSize === 'intro' ? rAccessor = 'introRadius' : rAccessor = 'realRadius';

	bubbles.transition()
		.attr('r', d => d[rAccessor]);

	simulation.nodes(currentData)
		.alpha(1)
		.restart();
}

function filter(gender, nationality, age, status) {
	massMouseoverOn(0, false);

	if (gender) genderFilter = gender;
	if (nationality) nationalityFilter = nationality;
	if (age) ageFilter = age;
	if (status) statusFilter = status;

	currentData = allFormattedData.filter(d => d.status === statusFilter && d.gender === genderFilter && d.age === ageFilter && d.nationality === nationalityFilter);
	//currentData.unshift(textNode);
	currentData.unshift(mouseNode);

	currentData.forEach(d => {
		d.x = d.questionX;
		d.y = d.questionY;
	})

	simulation.stop();

	// Apply the general update pattern to the nodes.
	bubbles = svg.selectAll('.bubble').data(currentData, d => d.key);

	bubbles.exit().attr('r', 10)
		.attr('fill', 'green')
		.remove();

	bubbles.each(function(d) {
			d.x = +d3.select(this).attr('cx');
			d.y = +d3.select(this).attr('cy');
		})
		.transition()
		.duration(1000)
		.attr('r', d => d[rAccessor])

	const bubblesE = bubbles
		.enter()
		.append('circle')
		.classed('bubble', true)
		.attr('cx', d => d.questionX)
		.attr('cy', d => d.questionY)
		//.attr('r', 0)
		.attr('r', 0)
		.attr('stroke', '#242428')
		.attr('stroke-width', 1)
		.on('mouseover', mouseover)
		.on('mouseout', mouseout);

	bubbles = bubbles.merge(bubblesE);

	bubbles.attr('visibility', d => d.fake ? 'hidden' : 'visible')
		.attr('fill', d => d.color)

	bubbles.transition()
		.delay(500)
		.duration(1000)
		.attr('r', d => d[rAccessor]);

	// Update and restart the simulation.
	simulation.nodes(currentData)
		.alpha(1).restart();

	/*
	timeout = setTimeout(function() {
		moveQuestionLabels();
	}, 500);
	*/

	massMouseoverOn(1500, true);
}

function magnetizeSVG(magnetized) {
	if (magnetized) {
		svg.on('mousemove', function() {
			const p1 = d3.mouse(this);
			currentData[0].fx = p1[0];
			currentData[0].fy = p1[1];
			//currentData[1].fx = vizParameters.centerX;
			//currentData[1].fy = vizParameters.height - 100;

			simulation.alpha(0.8).restart(); //reheat the simulation
		});
	} else {
		currentData[0].fx = 30000;
		currentData[0].fy = 30000;
		//currentData[1].fx = 30000;
		//currentData[1].fy = 30000;

		svg.on('mousemove', function() {

		});
	}
}

function buildQuestionLabels() {
	const questions = Object.keys(questionsToNeeds);

	const questionLabels = graphic_container.selectAll('.cv-question-label')
		.data(questions);

	questionLabels.enter()
		.append('p')
		.attr('class', 'cv-question-label')
		.text(d => lang.translateViz('cv', `Question--${d}`))
		.style('color', d => needsToColors[questionsToNeeds[d]])
		.style('left', d => `${questionCoords[d].x}px`)
		.style('top', d => `${questionCoords[d].y}px`)
		.style('opacity', 0)
}

function moveQuestionLabels(delay = 0, duration = 1000) {
	const questions = Object.keys(questionsToNeeds);
	const splitMassCoords = {}

	questions.forEach(question => {
		const questionData = currentData.filter(d => d.question === question);
		let questionY = isMobile ? d3.mean(questionData, d => d.y) : d3.min(questionData, d => d.y);
		const questionX = d3.mean(questionData, d => d.x);

		if (isMobile && question === 'More energy') questionY += 20;

		splitMassCoords[question] = {
			questionX,
			questionY,
		};
	});

	graphic_container.selectAll('.cv-question-label')
		.transition()
		.duration(duration)
		.style('left', d => `${splitMassCoords[d].questionX}px`)
		.style('top', d => `${splitMassCoords[d].questionY}px`)
		//.style('left', d => `${questionCoords[d].x}px`)
		//.style('top', d => `${questionCoords[d].y}px`)
		.transition()
		.duration(400)
		.style('opacity', 1);
}

function showQuestionLabels() {
	graphic_container.selectAll('.cv-question-label')
		.transition()
		.duration(1000)
		.style('opacity', 1);
}

function removeQuestionLabels() {
	graphic_container.selectAll('.cv-question-label')
		.transition()
		.remove();
}

function setupMouseoverText() {
	copy_panel.selectAll('.cv-mouseover')
		.style('pointer-events', 'all')
		.on('mouseover', function() {
			mouseout();

			const id = d3.select(this).attr('id');
			if (id === 'cv-mouseover-health') mouseoverGroup('3', '3');
			if (id === 'cv-mouseover-multiple') mouseoverGroup('2,3,9', '3');
		})
		.on('mouseout', mouseoutGroup);
}

function setupMouseoverButtons() {
	/*
	copy_panel.selectAll('.chapter-select')
		.on('mouseover', function() {
			const need = d3.select(this).attr('data-need');
			const needCapitalized = need.charAt(0).toUpperCase() + need.slice(1)
			console.log(needCapitalized);
			mouseoverNeed(needCapitalized);
		})
		.on('mouseout', mouseoutNeed);
	*/
}

function removeMouseoverText() {
	d3.selectAll('.cv-mouseover')
		.style('pointer-events', 'none');
}

function removeMouseoverButtons() {
	/*
	copy_panel.selectAll('.chapter-select')
		.on('mouseover', null)
		.on('mouseout', null);
	*/
}

function massMouseoverOn(delay = 0, on = false) {
	svg.selectAll('.bubble')
		.transition()
		.delay(delay)
		.duration(0)
		.style('pointer-events', on ? 'all' : 'none');
}

function mouseover(d) {
	if (mouseoverType === 'need') {
		mouseoverNeed(d.need);
	} else {
		mouseoverGroup(d.group, d.question);
	}
}

function mouseoverGroup(group, question) {
	stopSimulation();

	svg.selectAll('.bubble')
		.transition()
		.duration(200)
		.style('fill-opacity', d => d.group === group ? 1 : .3);
	//.style('stroke-opacity', d => d.group === group ? 1 : .3);

	const groupData = currentData.filter(d => d.group === group);

	const questions = Object.keys(questionsToNeeds),
		questionIndex = questions.indexOf(question),
		questionsOrdered = questions.slice(questionIndex).concat(questions.slice(0, questionIndex));

	groupData.sort((a, b) => questionsOrdered.indexOf(a.question) - questionsOrdered.indexOf(b.question));

	groupData.forEach((d, i) => {
		if (groupData.length !== 2 || i !== 1) {
			const nextCircle = i < groupData.length - 1 ? groupData[i + 1] : groupData[0];

			svg.append('line')
				.attr('class', 'cv-connector')
				.attr('x1', d.x)
				.attr('x2', d.x)
				.attr('y1', d.y)
				.attr('y2', d.y)
				.attr('stroke', '#B3B3BA')
				.attr('stroke-width', d[rAccessor] * 2)
				.attr('stroke-opacity', .3)
				.attr('stroke-linecap', 'round')
				.transition()
				.delay(i * 200)
				.duration(200)
				.attr('stroke-opacity', .3)
				.attr('x2', nextCircle.x)
				.attr('y2', nextCircle.y)

			svg.append('circle')
				.attr('class', 'circle')
				.attr('class', 'cv-connector')
				.attr('cx', d.x)
				.attr('cy', d.y)
				.attr('r', d[rAccessor])
				.attr('fill', d.color);
		}
	});

	const tooltipPos = getTooltipPos(groupData);

	tooltip.style('left', `${tooltipPos.xPos}px`)
		.style('top', `${tooltipPos.yPos}px`)
		.classed('is-visible', true);

	tooltip.select('.cv-tooltip__metric')
		.text(() => {
			const spacer = lang.getCurrentLang() == 'de-DE' || lang.getCurrentLang() == 'es-ES' ? ' ' : '';
			return `${(+groupData[0].pct * 100).toFixed(2)}${spacer}%`
		});

	tooltip.select('.cv-tooltip__description')
		.text(groupData.length === 1 ? lang.translateViz('cv', 'Tooltip--Only') : lang.translateViz('cv', 'Tooltip--Combo'));
}

function mouseoverNeed(need) {
	stopSimulation();

	svg.selectAll('.bubble')
		.transition()
		.duration(200)
		.style('fill-opacity', d => d.need === need ? 1 : 0)
		.style('stroke-opacity', d => d.need === need ? 1 : 0);
}

function mouseout(d) {
	if (mouseoverType === 'need') {
		mouseoutNeed()
	} else {
		mouseoutGroup();
	};
}

function mouseoutGroup() {
	svg.selectAll('.cv-connector').remove();

	svg.selectAll('.bubble')
		.transition()
		.duration(200)
		.style('fill-opacity', 1);
	//.style('stroke-opacity', 1);

	tooltip.classed('is-visible', false);

	restartSimulation();
}

function mouseoutNeed() {
	svg.selectAll('.bubble')
		.transition()
		.duration(200)
		.style('fill-opacity', 1)
		.style('stroke-opacity', 1);

	restartSimulation();
};

function charge(d) {
	return -Math.pow(d[rAccessor], 2.05) * forceStrength;
	//return -d.radius * 8;
}

function stopSimulation() {
	simulation.stop();
}

function restartSimulation() {
	simulation.restart();
}

function setVizLocation(location) {
	currentLocation = location;
}

function getVizParameters() {
	isMobile = util.isMobile();

	const parameters = {};

	const container_width = graphic_container.node().offsetWidth,
		container_height = graphic_container.node().offsetHeight,
		header_height = header.node().offsetHeight,
		copy_panel_width = copy_panel.node().offsetWidth,
		copy_panel_height = copy_panel.node().offsetHeight;

	parameters.yOffset = header_height,
		parameters.fullWidth = container_width,
		parameters.fullHeight = container_height - parameters.yOffset,
		parameters.fullCenterX = parameters.fullWidth / 2,
		parameters.fullCenterY = parameters.fullHeight / 2 + parameters.yOffset,
		parameters.fullBottomY = container_height + container_height * .1;

	if (!isMobile) {
		const adjusted_width = container_width - copy_panel_width;

		parameters.width = adjusted_width,
			parameters.height = parameters.fullHeight,
			parameters.centerX = adjusted_width / 2,
			parameters.centerY = parameters.fullCenterY;

	} else {
		// const adjusted_height = container_height - copy_panel_height;
		const adjusted_height = (parameters.fullHeight / 2);

		parameters.width = parameters.fullWidth,
			parameters.height = adjusted_height;

		parameters.centerX = parameters.fullCenterX,
			parameters.centerY = parameters.fullCenterY - (copy_panel_height / 2);
	}

	const rMaxScale = d3.scaleThreshold().domain([400, 500, 600, 700, 800, 1000, 1400]).range([12, 14, 16, 24, 32, 40, 50, 60]);
	const rOffsetScale = d3.scaleThreshold().domain([400, 500, 1000, 1500]).range([90, 110, 160, 200, 200]);

	const screenMin = Math.min(parameters.width, parameters.height);

	parameters.rMax = rMaxScale(screenMin);
	parameters.rOffset = rOffsetScale(screenMin);

	return parameters;
}

function getMassCoords(location) {
	let xPos = 0,
		yPos = 0;

	if (location === 'center') {
		xPos = vizParameters.centerX,
			yPos = vizParameters.centerY;
	} else if (location === 'bottomCenter') {
		xPos = vizParameters.fullCenterX,
			yPos = vizParameters.fullBottomY;
	} else if (location === 'fullCenter') {
		xPos = vizParameters.fullCenterX,
			yPos = vizParameters.fullCenterY;
	} else if (location === 'outOfView') {
		xPos = vizParameters.fullCenterX,
			yPos = vizParameters.fullBottomY * 2;
	} else if (location === 'outOfViewTop') {
		xPos = vizParameters.fullCenterX,
			yPos = -200;
	}

	currentLocation = location;

	return {
		xPos: xPos,
		yPos: yPos,
	}
}

function getQuestionCoords() {
	const centerX = vizParameters.centerX,
		centerY = vizParameters.centerY,
		radiusX = vizParameters.width / 2,
		radiusY = vizParameters.height / 2,
		radius = Math.min(radiusX, radiusY) - vizParameters.rOffset;

	const questions = Object.keys(questionsToNeeds),
		questionCount = questions.length,
		questionAngle = Math.round(360 / questionCount);

	const coords = {};

	questions.forEach((question, index) => {
		const angleDeg = questionAngle * index,
			angleRad = (angleDeg - 90) * Math.PI / 180,
			x = centerX + (radius * Math.cos(angleRad)),
			y = centerY - (radius * Math.sin(angleRad));

		coords[question] = {
			x: x,
			y: y,
		}
	})

	return coords;
}

function getEllipseCoords() {
	let centerX = vizParameters.centerX,
		centerY = vizParameters.centerY,
		radiusX = Math.min(vizParameters.width / 2, (2 * vizParameters.height) / 3) - vizParameters.rOffset,
		radiusY = Math.min(vizParameters.height / 2, (2 * vizParameters.width) / 3) - vizParameters.rOffset,
		radius = Math.min(radiusX, radiusY);

	if (!isMobile) {
		radiusX = radius,
			radiusY = radius;
	}

	const questions = Object.keys(questionsToNeeds),
		questionCount = questions.length;

	const coords = {};

	questions.forEach((question, index) => {
		const t = Math.tan(index * Math.PI / questionCount + Math.atan(2 * radiusY / radiusX) / 2);

		const x = centerX + radiusX * (1 - t ** 2) / (1 + t ** 2),
			y = centerY + radiusY * 2 * t / (1 + t ** 2);

		coords[question] = {
			x,
			y
		}
	})

	return coords
}

function getTooltipPos(d) {
	const tooltipWidth = tooltip.node().offsetWidth,
		tooltipHeight = tooltip.node().offsetHeight;

	const minXPos = tooltipWidth / 2 + 5,
		maxXPos = vizParameters.width - (tooltipWidth / 2) - 5;

	const minYPos = header.node().offsetHeight,
		maxYPos = vizParameters.height - header.node().offsetHeight - tooltipHeight - 10;

	const rawXPos = d[0].x,
		rawYPos = d[0].y + d[0][rAccessor] + 5;

	let xPos = rawXPos,
		yPos = rawYPos;

	if (rawXPos < minXPos) {
		xPos = minXPos;
	} else if (rawXPos > maxXPos) {
		xPos = maxXPos;
	}

	if (rawYPos < minYPos) {
		yPos = minYPos;
	} else if (rawYPos > maxYPos) {
		yPos = maxYPos;
	}

	return {
		xPos,
		yPos,
	}

}

function shuffle(array) {
	array.sort(() => Math.random() - 0.5);
}

export default {
	init,
	resize,
	//drawSingleOrganized,
	drawMass,
	moveMass,
	splitMass,
	clearMass,
	filter,
	updateMassRadius,
	massMouseoverOn,
	next,
	setupMouseoverButtons,
	stopSimulation,
};

d3.selection.prototype.moveToFront = function() {
	return this.each(function() {
		this.parentNode.appendChild(this);
	});
};